import React, { useEffect, useState } from "react";
import * as path from "../Routes/RoutePaths";
import axios from "axios";
import Select from "react-select";
import swal from "sweetalert";
import { useHistory } from "react-router-dom";
import { handleSelectAll } from "../Const/Status";
import { logout_func2 } from "../Const/logoutCommon";
import { BASE_URL } from "../Const/Url";
import { showToast } from "../../utils/ToastHelper";
import RequiredLabel from "../CustomCommons/RequiredLabel";
import SelectOpenWithPagginationDynamic from "../Const/SelectOpenWithPagginationDynamic";

const Add_Theme_Product = () => {
  const history = useHistory();
  const [themeId, setThemeId] = useState(null);
  const [selectProduct, setSelectProduct] = useState([]);
  const [inputQuery, setInputQuery] = useState("");
  const [inputQueryTheme, setInputQueryTheme] = useState("");
  const [productList, setProductsList] = useState([]);
  const [theme, setTheme] = useState([]);
  const inputProduct = (inputValue) => {
    setInputQuery(inputValue);
  };
  const inputTheme = (inputValue) => {
    setInputQueryTheme(inputValue);
  };
  const getTheme = () => {
    const url = `${BASE_URL}api/v1/inventory/inventory/themes/?limit=50&search=${inputQueryTheme}`;

    axios
      .get(url)
      .then((res) => {
        // console.log(res.data.data.results);
        const result = res.data.data.results;
        const options = result.map((curr) => ({
          label: curr.name,
          value: curr.id,
        }));
        setTheme(options);
      })
      .catch((err) => {
        const message = JSON.parse(err.request.response).message;
        // console.log(err.request.response);
        if (
          message === "Invalid token." ||
          JSON.parse(err.request.response).code === 401
        ) {
          // history.push('/login')
          logout_func2(0, history);
        }
      });
  };

  // Debounced search for theme options
  useEffect(() => {
    const handle = setTimeout(() => {
      getTheme();
    }, 300);
    return () => clearTimeout(handle);
  }, [inputQueryTheme]);

  const handleMultiInputChange = (newValue, actionMeta) => {
    setSelectProduct(newValue);
  };
  const postOffer = () => {
    const url = `${BASE_URL}api/v1/inventory/inventory/add-product-to-theme`;
    const data = {
      theme_id: themeId,
      products: selectProduct ? selectProduct.map((obj) => obj.value) : [],
    };
    axios
      .post(url, data)
      .then((res) => {
        if (res.data.status) {
          showToast("success", "Theme product added.");
          history.push(path.theme_products);
        }
      })
      .catch((err) => {
        const message = JSON.parse(err.request.response).message;
        const errorMsg = JSON.parse(err.request.response).errors;
        for (let key in errorMsg) {
          showToast("error", `${key} : ${errorMsg[key][0]}`);
        }
        showToast("error", message);
      });
  };

  return (
    <div className="categorey-parent new-categorey-parent an">
      <div className="bg-white  add-div">
        <div
          className="d-flex align-items-center"
          style={{ padding: "20px 35px ", border: "0.5px solid #E0E0E0" }}
        >
          <h3 style={{ fontSize: "23px", marginTop: "6px" }}>
            Add Multiple Theme Product
          </h3>
        </div>
        <div
          style={{
            padding: "20px 35px ",
            borderBottom: " 0.5px solid #E0E0E0",
            borderRight: " 0.5px solid #E0E0E0",
            borderLeft: "0.5px solid #E0E0E0",
          }}
          className="row"
        >
          <div className="col-12 mb-3">
            <RequiredLabel text="Theme" />
            <div className="position-relative">
              <Select
                options={theme}
                isClearable
                isSearchable
                onInputChange={(val) => setInputQuery(val)}
                onChange={(opt) => setThemeId(opt ? opt.value : null)}
                value={theme.find((o) => o.value === themeId) || null}
                placeholder="Search and select theme"
              />
            </div>
          </div>
          <div className="col-12 ">
            <RequiredLabel text="Products" />
            <div className="position-relative">
              <SelectOpenWithPagginationDynamic
                handleMultiInputChange={handleMultiInputChange}
                inputProduct={inputProduct}
                ProductsList={productList}
                defaultValue={selectProduct}
                setProductsList={setProductsList}
                inputQuery={inputQuery}
                selectAll={() => handleSelectAll(productList, setSelectProduct)}
                url1={`/api/v1/inventory/inventory/products/?has_theme=False`}
                url2={`/api/v1/inventory/inventory/products/?query=${inputQuery}&has_theme=False`}
              />
            </div>
          </div>

          {/* ------------Save And Cancel------------ */}
          <div className="mt-2 mt-md-4" style={{ marginLeft: "-10px" }}>
            <button
              onClick={postOffer}
              className=" save-btn  me-2 mt-2"
              style={{ background: "#000", color: "white" }}
            >
              Save
            </button>
            <button
              onClick={() => history.push(path.theme_products)}
              className="save-btn mt-2"
              style={{ border: ".4px solid #E0E0E0 !important" }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Add_Theme_Product;
